//@ts-nocheck
import { BANK_STATEMENT_TABLE_HEADER } from "./headers";
import DefaultCell from "layouts/ecommerce/orders/order-list/components/DefaultCell";
import Checkbox from "@mui/material/Checkbox";
import { formatCurrencyUSD } from "utils/CommonUtils";

export interface Columns {
  Header: string;
  accessor: string;
  width?: number;
  minWidth?: number;
  Cell?: any;
}
export const COLUMNS = [
  {
    Header: BANK_STATEMENT_TABLE_HEADER.DATE,
    accessor: "txnDate",
    minWidth: 80,
    Cell: ({ value }: any) => <DefaultCell value={value} />,
  },
  {
    Header: BANK_STATEMENT_TABLE_HEADER.TYPE,
    accessor: "type",
    minWidth: 80,
    Cell: ({ value }: any) => {
      const capitalizeFirstLetter = (str: string) => {
        if (!str) return str;
        return str.charAt(0).toUpperCase() + str.slice(1);
      };

      return <DefaultCell value={capitalizeFirstLetter(value)} />;
    },
  },
  {
    Header: BANK_STATEMENT_TABLE_HEADER.DESCRIPTION,
    accessor: "description",
    minWidth: 200,
    Cell: ({ value }: any) => value,
  },
  {
    Header: BANK_STATEMENT_TABLE_HEADER.MEMO,
    accessor: "memo",
    minWidth: 200,
    Cell: ({ value }: any) => <DefaultCell value={value} />,
  },
  {
    Header: BANK_STATEMENT_TABLE_HEADER.BANK_NAME,
    accessor: "accountName",
    Cell: ({ value }: any) => <DefaultCell value={value} />,
  },
  {
    Header: BANK_STATEMENT_TABLE_HEADER.ACCOUNT_NUMBER,
    accessor: "accountNumber",
    Cell: ({ value }: any) => <DefaultCell value={value} />,
  },
  {
    Header: BANK_STATEMENT_TABLE_HEADER.AMOUNT,
    accessor: "amount",
    Cell: ({ value }: any) => <DefaultCell value={formatCurrencyUSD(value)} />,
  },
  {
    Header: "True",
    accessor: "trueval",
    minWidth: 80,
    Cell: ({ value }: any) => {
      return <Checkbox checked={value === true} />;
    },
  },
];

export default COLUMNS;
